import { z } from "zod";

import { MAX_LENGTH } from "@/components/ui/OTPInput/constants";

export const verifyMfaSchema = z.object({
  code: z.string().length(MAX_LENGTH, "Verification code must be 6 digits"),
});

export type VerifyMfaFormValues = z.infer<typeof verifyMfaSchema>;
